let language = {
    "ESHOPPER-ALERT-INFO-TITLE": "Resend Email",
    "ESHOPPER-ALERT-INFO-CONTENT": "success to resend Email",
    "ESHOPPER-ALERT-WARN-CONTENT": "The return address is missing a postal code, please fill it in.",
    "ESHOPPER-ALERT-WARN-TITLE-SAVE": "Failed",
    "ESHOPPER-ALERT-WARN-CONTENT-SAVE": "Save failed ! ",
    "ESHOPPER-ALERT-MESSAGE": "Save Successfully!",
};

export { language }